var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.56 3C8.62 3 3 8.62 3 15.56C3 18 3.71 20.27 4.91 22.2L3.42 26.83C3.25 27.36 3.76 27.86 4.29 27.68L8.78 26.13C10.74 27.39 13.06 28.13 15.56 28.13C22.5 28.13 28.12 22.51 28.12 15.57C28.12 8.63 22.5 3 15.56 3Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 16.68C11.7774 16.68 12.44 16.0174 12.44 15.2C12.44 14.3826 11.7774 13.72 10.96 13.72C10.1426 13.72 9.47998 14.3826 9.47998 15.2C9.47998 16.0174 10.1426 16.68 10.96 16.68Z",
    fill: "#D2D2D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 16.68C16.3074 16.68 16.97 16.0174 16.97 15.2C16.97 14.3826 16.3074 13.72 15.49 13.72C14.6726 13.72 14.01 14.3826 14.01 15.2C14.01 16.0174 14.6726 16.68 15.49 16.68Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1699 16.68C20.9873 16.68 21.6499 16.0174 21.6499 15.2C21.6499 14.3826 20.9873 13.72 20.1699 13.72C19.3526 13.72 18.6899 14.3826 18.6899 15.2C18.6899 16.0174 19.3526 16.68 20.1699 16.68Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.5d15054e4551157bcea25bffbea7e42e.svg";
export { ForwardRef as ReactComponent };